type Options = Partial<NewsletterOptions>;

export interface NewsletterElement extends HTMLElement {
  newsletter?: Newsletter;
}

export interface NewsletterOptions {
  confirmationMessageSelector: string;
  errorMessageSelector: string;
  newsletterFormSelector: string;
  visibilityClassName: string;
  ometriaQueryString: string;
}

export class Newsletter {
  static defaults = {
    confirmationMessageSelector: '[data-newsletter-confirmation]',
    errorMessageSelector: '[data-newsletter-error]',
    newsletterFormSelector: '[data-newsletter-form]',
    ometriaQueryString: 'ometria_form_ok',
    visibilityClassName: 'is-visible',
  };
  options: NewsletterOptions;
  element: NewsletterElement;

  constructor(element: NewsletterElement, options: Options) {
    if (!element || element.newsletter) {
      return;
    }

    element.newsletter = this;
    this.element = element;
    this.options = {
      ...Newsletter.defaults,
      ...this.element.dataset,
      ...options,
    };

    this.binding();
  }

  get form(): HTMLFormElement | null {
    return this.element.getElementsByTagName('form').item(0) as HTMLFormElement;
  }

  get checkbox(): HTMLInputElement | null {
    return document.getElementById('newsletterCheckbox') as HTMLInputElement;
  }

  get confirmationMessage(): HTMLElement | null {
    return document.querySelector(
      this.options.confirmationMessageSelector,
    ) as HTMLInputElement;
  }

  get newsletterForm(): HTMLElement | null {
    return document.querySelector(
      this.options.newsletterFormSelector,
    ) as HTMLElement;
  }

  get error(): HTMLElement | null {
    return document.querySelector(this.options.errorMessageSelector);
  }

  get newsletterSubmitted(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    const ometriaStatus = urlParams.get(this.options.ometriaQueryString);

    if (ometriaStatus === 'Y') {
      return true;
    } else {
      return false;
    }
  }

  toggleVisibility(element: Element | null) {
    if (!element) {
      return;
    }
    element.classList.toggle(this.options.visibilityClassName);
  }

  checkConsent(event: Event) {
    if (!this.checkbox) {
      return;
    }

    if (!this.checkbox.checked) {
      event.preventDefault();
      this.toggleVisibility(this.error);
    }
  }

  displayConfirmation() {
    if (
      this.newsletterSubmitted &&
      this.confirmationMessage &&
      this.newsletterForm
    ) {
      this.confirmationMessage.classList.remove('is-hidden');
      this.newsletterForm.classList.add('is-hidden');

      this.confirmationMessage.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  binding() {
    if (!this.form) {
      return;
    }
    window.addEventListener(
      'DOMContentLoaded',
      this.displayConfirmation.bind(this),
    );
    this.form.addEventListener('submit', this.checkConsent.bind(this));
  }
}
